import { positionTypes } from "segments/desktop/core-components/images-grid/images-grid-service";

export default {
  images: [],
  imagePosition: positionTypes.CENTER_CENTER,
  isIcon: false
};
